import { PRESETS_SALVAMENTO } from '../../dominio/tabletop/presetsSalvamento'
import type { CenaTabletop, ObjetoTabletop } from '../../dominio/tabletop/tipos'

interface Props {
  cena: CenaTabletop
  selecionado: ObjetoTabletop | null
  aoSelecionar: (id: string) => void
  aoAlterarHistoria: (texto: string) => void
  /** Abre um dos cenários de exemplo (técnicas de salvamento, canal, cisterna, trabalho em altura). */
  aoCarregarCenario: (id: string) => void
}

/**
 * O painel "Cenário": a história da ocorrência, os cenários de exemplo de
 * salvamento terrestre e em altura e a lista do que está na mesa.
 */
export function PainelMesaTabletop(p: Props) {
  return <div className="tt-painel-mesa">
    <h3>História inicial</h3>
    <label className="campo">
      <span>Contexto da ocorrência</span>
      <textarea aria-label="História inicial" rows={6} value={p.cena.historiaInicial ?? ''}
        placeholder="Escreva livremente a história desta ocorrência…"
        onChange={e => p.aoAlterarHistoria(e.target.value)} />
    </label>
    <p className="dica">Salvo automaticamente com a cena. Todos podem consultar e editar.</p>

    <h3>Cenários de exemplo</h3>
    <p className="dica">Abrem em modo Montar, prontos para editar. Abrir um exemplo substitui o que está na mesa.</p>
    <div className="tt-galeria-cenarios" role="group" aria-label="Cenários de exemplo">
      {PRESETS_SALVAMENTO.map(preset => <button type="button" key={preset.id} className="tt-cartao-cenario"
        onClick={() => p.aoCarregarCenario(preset.id)}>
        <div className="tt-cartao-cenario__cabecalho"><strong>{preset.titulo}</strong></div>
        <p className="tt-cartao-cenario__descricao">{preset.descricao}</p>
      </button>)}
    </div>

    <details>
      <summary>Elementos na mesa ({p.cena.objetos.length})</summary>
      <div className="tt-lista-mesa">
        {p.cena.objetos.map(o => <button type="button" key={o.id}
          aria-pressed={p.selecionado?.id === o.id} onClick={() => p.aoSelecionar(o.id)}>
          {o.nome}{o.bloqueado ? ' · Bloqueado' : ''}{o.oculto ? ' · Oculto' : ''}
        </button>)}
      </div>
    </details>
  </div>
}
